import { initialState } from '@components/templates/LandingPageForm/utils';
import { InputState, FieldName } from '@helpers/interfaces/form';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { setNumberOfEmployees } from "@features/planSlice";
// import { setCompanyName, setContactNumber, setEmailAddress, setEmployeeName } from "@features/userSlice";


export const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
      setOnChangeField: (state: InputState, action: PayloadAction<{fieldName:FieldName, value:string}>) => {
        const {fieldName, value} = action.payload
        const fieldVal = state[(fieldName as FieldName)];
        const { regEx } = fieldVal;
        let error = null;
        // Since "phone" is the last input field on the first form page so instead of checking validation onBlur, we check it onChange
        if (fieldName === "phone" && fieldVal.error === null) {
            // Since we want to start
            if (value.trim().length === 10) {
                error = !new RegExp(regEx).test(value.trim())
            }
        } else {
            // Since we want to run the validation logic on an InputField "onChange" after the error is already set to "true" or "false", as opposed to the initial "null" state
            error = fieldVal.error === false || fieldVal.error === true ? !new RegExp(regEx).test(value.trim()) : error
        }
        state = {
            ...state,
            [fieldName]: {
                ...fieldVal,
                value: value,
                inactive: false,
                error
            }
        };
      },
      setOnBlur: (state: InputState) => { 
        const validatedFilledFields:any = state
        // eslint-disable-next-line
        Object.keys(state).map((key: string) => {
            const fieldVal=state[key as FieldName] 
            if (!fieldVal.inactive) {
                const { regEx, value } = fieldVal;
                const error = !new RegExp(regEx).test(value.trim())
                validatedFilledFields[key as FieldName] = {
                    ...fieldVal,
                    error
                }
            }
        })
        return {
            ...state,
            ...validatedFilledFields
        }
      }
  },
});

export const {setOnChangeField, setOnBlur} = formSlice.actions;

export default formSlice.reducer;
